import { TTalentNationality } from "@/api/services/main/talent/dtos/get-talent-list.dto";
import { TTalentLanguageCertificates } from "@/features/talent/types/talentForm";
import { TFilter } from "@/api/services/main/case/dtos/create-case.dto";

export type TCaseBasicInfo = {
  name: string;
  managementNumber: string;
  personInChargeId?: number | undefined;
  memo?: string | null;
  talentFilter: TFilter;
};

export type TCaseTalent = {
  talentNumber: string;
  fullName: string;
  nationalityName: string;
  isRecommendedTalent: boolean;
  nationality: TTalentNationality;
  gender: string;
  residenceStatus: string;
  languageCertificates?: TTalentLanguageCertificates[] | null;
};

export const InterviewMethod = {
  ONLINE: 1,
  OFFLINE: 2,
} as const;
export type TInterviewMethod = (typeof InterviewMethod)[keyof typeof InterviewMethod];

export const MeetingToolType = {
  ZOOM: 1,
  TEAMS: 2,
  MEET: 3,
} as const;
export type TMeetingToolType = (typeof MeetingToolType)[keyof typeof MeetingToolType];

export type TCaseScheduleForm = {
  dateTimeTalent?: string | null;
  isConfirm?: boolean | null;
  dateConfirm?: string | null;
  startTimeConfirm?: string | null;
  interviewMethod?: number | null;
  meetingToolType?: number | null;
  meetingId?: string | null;
  passcode?: string | null;
  url?: string | null;
  talentIds?: number[] | null;
  originalDateConfirm?: string | null;
  originalStartTimeConfirm?: string | null;
};

export type TCaseScheduleItem = {
  id?: number;
  dateTimeTalent: string;
  isConfirm?: boolean | null;
  dateConfirm?: string | null;
  startTimeConfirm?: string | null;
  interviewMethod?: TInterviewMethod | null;
  meetingToolType?: TMeetingToolType | null;
  meetingId?: string | null;
  passcode?: string | null;
  talents?: Talent[];
  url?: string | null;
};

export type Talent = {
  id: number;
  fullName: string;
  nickname?: string;
  isRecommendedTalent?: boolean;
};
